import type { AcademyContent } from "@/components/ui/arbi-academy-modal";

export const TASKS_ACADEMY_CONTENT: AcademyContent = {
  type: "tasks",
  typeLabel: "Tasks",
  title: "Tasks & Automated Execution",
  description:
    "Learn how tasks power your recruiting workflow — from automatic step execution in sequences to manual follow-ups. This video covers task types, priorities, due dates, bulk actions, and how to keep your pipeline moving without dropping the ball.",
  duration: "3 mins",
  videoUrl: "https://www.youtube.com/watch?v=setu9Ir1miY",
  thumbnailUrl: "/assets/academy/tasks-thumbnail.png",
  accentColor: "#7dd3a8",
  typeColor: "#7dd3a8",
  docsUrl: "https://docs.neuroscale.ai/core/tasks",
};
